/**
 * Created by iamso on 24.05.21
 */

const Barrel = function (unit) { 
    UnitComponent.call(this, unit);

    const sprite = bundles.merge.frames.barrel_ad_icon_png || bundles.buttons_inlined_icons.frames.ad_icon_png;
    this.unit.setPrizes({ sprite });

    this.onRemove = function () {};
    this.onReward = function () {};
    this.onPrizeChanged = function () {};
};

Barrel.prototype = Object.create(UnitComponent.prototype);
Barrel.prototype.constructor = Barrel;

Barrel.prototype.onPrizeHarvested = function () {
    this.remove();
};

Barrel.prototype.onPrizeNotHarvested = function () {
    this.prizes = this.unit.prizes.slice();
    this.onPrizeChanged();
};

Barrel.prototype.onSpawn = function () {
    if (this.view) {
        this.view.onSpawn();
    }
};

Barrel.prototype.onDestruction = function () {
    if (this.view) {
        this.view.onDestruction();
    }
};

Barrel.prototype.restorePrizes = function (stored) {
    this.prizes = stored.map((key) => Unit.ParseKey(key));

    this.unit.setPrizes(this.prizes);
};

Barrel.prototype.remove = function () {
    this.onDestruction();
    this.unit.remove(true);

    this.prizes = undefined;

    this.onRemove();
};

Barrel.prototype.getSaveData = function () {
    const data = {
        stage: this.unit.stage
    };

    if (this.prizes) {
        data.prizes = this.prizes.map((unit) => Unit.GetKey(unit));
    }

    return data;
};

Barrel.prototype.awardItem = function (rewards) {
    this.prizes = rewards;
    this.unit.setPrizes(this.prizes);

    this.onReward();
};

Barrel.prototype.showItemAds = function (rewards, onCollectPrizes) {
    this.playingVideo = true;

    cleverapps.rewardedAdsManager.playRewarded(AdsLimits.TYPES.BARREL, () => {
        this.awardItem(rewards);

        onCollectPrizes();
    });
};

Barrel.prototype.handlePrizes = function () {
    if (this.prizes) {
        return false;
    }

    cleverapps.focusManager.display({
        focus: "BarrelAdsOpen",
        control: ["MenuBarGoldItem", "MenuBarCoinsItem"],
        action: function (f) {
            new BarrelAdsWindow(this);
            cleverapps.focusManager.onceNoWindowsListener = f;
        }.bind(this)
    });

    return true;
};

Barrel.prototype.spawn = function () {
    const pos = Map2d.currentMap.regions.barrel.positions[0];
    this.unit.setPosition(pos.x, pos.y);

    Map2d.currentMap.add(Map2d.LAYER_UNITS, this.unit.x, this.unit.y, this.unit);
    Map2d.currentMap.onAddUnit(this.unit.x, this.unit.y, this.unit);
    this.onSpawn(this);
};

Barrel.prototype.listItems = function () {
    PseudoRandom.GET().seed(`${this.unit.stage}${Math.round(Date.now() / cleverapps.parseInterval("1 hour"))}`);

    const chosen = [];
    for (let i = 0; i < 3; i++) {
        const reward = PseudoRandom.GET().choose(Barrel.ITEMS[i]);
        chosen.push(reward);
    }

    return chosen;
};

Barrel.ITEMS = [
    [
        {
            units: [{ code: "sacks", stage: 0 }],
            amount: 1
        },
        {
            units: [{ currentType: "fruit", stage: 4 }],
            amount: 3
        }
    ],
    [
        {
            units: [{ currentType: "hero", stage: 1 }],
            amount: 2
        },
        {
            units: [{ currentType: "resource", stage: 1 }],
            amount: 3
        }
    ],
    [
        {
            units: [{ code: "wands", stage: 0 }],
            amount: 1
        },
        {
            units: [{ code: "worker", stage: 0 }],
            amount: 2
        }
    ]
];
